var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"certificate-main",style:({padding:_vm.userAgent==1?'0':'130px 410px 147px'})},[_c('img',{attrs:{"src":_vm.img,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }